





























import { Component, Vue } from 'vue-property-decorator';
import { pankuzuList } from '@/@types/LibraryComponent';

@Component({
  components: {},
})
export default class StorageSubHeader extends Vue {
  private searchAllIcon: string = 'mdi-magnify';
  private searchAllHeight: number = 20;
  private searchWord = '';

  private storageResult() {
    this.$router.push({name: 'storageResult'});
  }

  // private pankuzu: Array<pankuzuList> = [
  //   {
  //     text: 'ダッシュボード',
  //     disabled: false,
  //     href: 'breadcrumbs_dashboard',
  //   },
  //   {
  //     text: '資料',
  //     disabled: false,
  //     href: 'breadcrumbs_link_1',
  //   },
  //   {
  //     text: '要件定義',
  //     disabled: true,
  //     href: 'breadcrumbs_link_2',
  //   },
  // ];
}
